<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="680px">
    <v-card v-draggable-dialog class="profile-dialog-card entity-form-dialog">
      <EntityDialogHeader
        class="dialog-drag-handle"
        eyebrow="Billing"
        :title="dialogTitle"
        subtitle="Select a fee and the students whose charges should be included."
        icon="mdi-account-school-outline"
        close-label="Close student fee invoice dialog"
        @close="close"
      />

      <v-divider />

      <v-card-text class="profile-dialog-body entity-form-dialog__body">
        <section class="entity-form-dialog__section">
          <div class="entity-form-dialog__section-heading">
            <span><v-icon size="19" color="primary">mdi-receipt-text-plus-outline</v-icon></span>
            <div>
              <h3>Fee details</h3>
              <p>Choose the invoice date and fee product.</p>
            </div>
          </div>
          <v-row>
            <v-col v-if="mode === 'create'" cols="12" sm="6">
              <DateSelector v-model="Invoice.date" />
            </v-col>
            <v-col cols="12" :sm="mode === 'create' ? 6 : 12">
              <v-autocomplete v-model="selectedProduct" hide-no-data ref="productSearch" outlined
                prepend-inner-icon="mdi-magnify" dense :loading="loading" auto-select-first hide-details
                clearable id="productSearch" :items="Products" item-text="name" return-object label="Fee product">
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                  <v-spacer />
                  <v-chip v-if="item.isFee" color="primary" outlined x-small>School fee</v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </section>

        <section class="entity-form-dialog__section">
          <div class="entity-form-dialog__section-heading">
            <span><v-icon size="19" color="primary">mdi-account-multiple-check-outline</v-icon></span>
            <div>
              <h3>Students</h3>
              <p>Select one or more students to add.</p>
            </div>
          </div>
            <v-skeleton-loader v-if="loadingStudents" type="list-item-three-line@3" />
            <v-list v-else-if="Students.length" class="list-350 pa-0">
              <template v-for="(row, index) in Students">
                <v-list-item :key="index">
                  <!-- <v-list-item-avatar>
                    <v-btn icon>
                      <v-icon color="red" @click="deleteRow(row)">delete</v-icon>
                    </v-btn>
                  </v-list-item-avatar> -->
                  <v-checkbox v-model="row.selectedStudent">
                    <template v-slot:label>
                      <v-list-item-content>
                        <v-list-item-title style="color: black" class="text-capitalize font-weight-bold">{{ row.fullName
                          }} <span>- Parent Pay: {{ getTotalParentPay(row.ClassStudents) | currency
                            }}</span></v-list-item-title>
                        <v-list-item-subtitle class="caption" v-if="!row.ClassRoomStudents || !row.ClassRoomStudents.length">
                          <v-chip x-small color="warning" text-color="white" class="font-weight-bold" label>
                            Not assigned to a classroom
                          </v-chip>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="row && row.ClassStudents" class="font-weight-light">
                          <!-- <span v-for="(classRow, idx) in row.ClassStudents" :key="idx">{{ classRow.Class.name }}<span v-if="row.ClassStudents.length !== idx">, </span></span> -->
                          <div v-for="(classRow, idx) in row.ClassStudents" :key="idx">
                            {{ classRow.Class.name }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-checkbox>
                  <v-list-item-action-text>
                    <v-list-item-title v-if="row && row.ClassStudents" class="text-capitalize font-weight-bold">
                      <div v-for="(classRow, idx) in row.ClassStudents" :key="idx">
                        {{ getPrice(classRow) | currency }}
                        <!-- {{ classRow.Class.name }} -->
                      </div>
                      <!-- {{ getPrice(row.ClassStudents[0]) | currency }} -->
                    </v-list-item-title>
                  </v-list-item-action-text>
                </v-list-item>
              </template>
            </v-list>
            <v-alert v-else text type="info" class="mb-0">No active students were found for this parent.</v-alert>
        </section>
      </v-card-text>

      <v-divider />

      <v-card-actions class="profile-dialog-actions entity-form-dialog__actions">
        <v-btn text @click="close()">Cancel</v-btn>
        <v-btn color="primary" depressed :loading="loading" @click="submit()">
          <v-icon left small>{{ mode === 'add' ? 'mdi-plus' : 'mdi-check' }}</v-icon>{{ submitLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
// import teacherService from "../service.js";
import productService from "@/modules/Product/service";
import studentService from "@/modules/Student/service.js";
// import classService from "@/modules/Classes/service.js";
import DateSelector from "@/components/DateSelector";
import invoiceService from "@/modules/Invoice/service.js";

export default {
  props: {
    createDialog: {
      default: false,
    },
    parent: {
      type: Object,
    },
    mode: {
      type: String,
      default: "create",
    },
  },
  name: "create-invoice",
  data() {
    return {
      Products: [],
      selectedProduct: null,
      Invoice: {
        date: this.$moment().toISOString(),
      },
      StudentList: [],
      Classes: [],
      Students: [],
      selectedStudent: [],
      loading: false,
      loadingStudents: false,
      dialog: false,
      Teacher: null,
    };
  },
  components: {
    DateSelector,
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    dialogTitle() {
      return this.mode === "add" ? "Add Students to Invoice" : "Student Fee Invoice";
    },
    submitLabel() {
      return this.mode === "add" ? "Add to invoice" : "Create invoice";
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Teacher.name.$dirty) return errors;
      if (!this.$v.Teacher.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.Teacher = this.editTeacher;
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        // this.getTeacher();
        this.getStudents();
        this.getProduct();
      }
    },
  },
  methods: {
    getProduct() {
      this.loading = true;
      return productService.getAll({ isFee: true }).then((result) => {
        this.Products = result.data;
        this.loading = false;
      });
    },
    getTotalParentPay(obj) {
      let total = 0
      obj.map(row => {
        total += row.parentPay
      })
      return total
    },
    getPrice(classObj) {
      return classObj.parentPay + classObj.charity
    },
    getTotalPrice(classObj) {
      let total = 0
      classObj.map(row => {
        total += row.parentPay + row.charity
      })
      return total
      // return classObj.parentPay + classObj.charity
    },
    getStudents() {
      this.loadingStudents = true;
      return studentService
        .getAll({ CustomerId: this.parent.id, hideLeft: true, classStudents: true })
        .then((response) => {
          console.log("response", response);
          this.Students = response.data;
          this.Students.map(student => {
            student.selectedStudent = true
          })
          return response;
        })
        .finally(() => {
          this.loadingStudents = false;
        });
    },

    // getTeacher() {
    //   return teacherService.getById(this.Teacher.id).then((response) => {
    //     this.Teacher = response.data;
    //     console.log("response Teacher", this.Teacher);

    //     this.StudentList = this.Teacher.Students;
    //     return response;
    //   });
    // },
    submit() {
      this.Invoice.CustomerId = this.parent.id
      if (!this.selectedProduct) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: "Fee product not selected",
          });
        this.loading = false
        return true
      }
      let detail = []
      this.Students.map(student => {
        if (student.selectedStudent) {
          student.ClassStudents.map(row => {
            let studentRow = {
              ProductId: this.selectedProduct.id,
              name: `${this.selectedProduct.name} - Parent Pay: ${row.parentPay} (${student.fullName})`,
              price: row.parentPay + row.charity,
              total: row.parentPay + row.charity,
              parentPay: row.parentPay,
              StudentId: student.id,
              description: row.Class.name,
              qty: 1,
              cost: 0,
              ClassRoomId: row.ClassRoomId,
              ClassId: row.Class.id
            }
            detail.push(studentRow)
          })
        }
      })
      this.Invoice.InvoiceDetails = detail
      if (this.Invoice.InvoiceDetails.length <= 0) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: "No student selected",
          });
        this.loading = false
        return true
      }
      if (this.mode === "add") {
        this.$emit("add-details", detail);
        this.close();
        return true;
      }
      this.loading = true
      console.log('invoice', this.Invoice)
      return invoiceService
        .create(this.Invoice)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Invoice was created!",
            });
          this.$emit('submit')
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log("error creating invoice", error);
          this.loadingSaveBtn = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 6000,
            })
            .fire({
              icon: "error",
              title: error.data.message,
            });
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Teacher = {
        name: null,
      };
      this.selectedProduct = null;
      this.Students = [];
      this.Invoice = { date: this.$moment().toISOString() };
    },
  },
};
</script>
